import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { OccupancyTrendChart } from '../components/charts/OccupancyTrendChart';
interface OccupancyReportPageProps {
  onBackToOverview: () => void;
}
export const OccupancyReportPage: React.FC<OccupancyReportPageProps> = ({
  onBackToOverview
}) => {
  return <main className="flex-1 overflow-y-auto bg-gray-50 p-6" data-id="element-238">
      <div className="mb-6" data-id="element-239">
        <div className="flex items-center justify-between mb-4" data-id="element-240">
          <h1 className="text-2xl font-bold" data-id="element-241">
            Quarterly Occupancy Trends Report
          </h1>
          <button onClick={onBackToOverview} className="flex items-center px-4 py-2 bg-[#1f58b0] text-white rounded-md hover:bg-[#255db7] transition-colors" data-id="element-242">
            <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-243" />
            Back to Overview
          </button>
        </div>
        <p className="text-gray-600 mb-4" data-id="element-244">
          This report shows occupancy trends over the last quarter, including
          move-ins, move-outs, and overall occupancy rates.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6" data-id="element-245">
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-246">
            <h3 className="text-sm font-medium text-gray-500" data-id="element-247">
              Current Occupancy Rate
            </h3>
            <p className="text-2xl font-bold text-[#1f58b0]" data-id="element-248">92.4%</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-249">
            <h3 className="text-sm font-medium text-gray-500" data-id="element-250">
              Change from Previous Quarter
            </h3>
            <p className="text-2xl font-bold text-[#255db7]" data-id="element-251">+3.2%</p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow" data-id="element-252">
            <h3 className="text-sm font-medium text-gray-500" data-id="element-253">
              Projected Year-End Occupancy
            </h3>
            <p className="text-2xl font-bold text-[#f6d052]" data-id="element-254">94.5%</p>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-lg shadow p-4 mb-6" data-id="element-255">
        <h2 className="text-lg font-semibold mb-4" data-id="element-256">Occupancy Rate Trends</h2>
        <div className="h-64" data-id="element-257">
          <OccupancyTrendChart data-id="element-258" />
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-259">
        <div className="bg-white rounded-lg shadow p-4" data-id="element-260">
          <h2 className="text-lg font-semibold mb-4" data-id="element-261">
            Move-In/Move-Out Analysis
          </h2>
          <table className="min-w-full" data-id="element-262">
            <thead data-id="element-263">
              <tr className="bg-gray-50" data-id="element-264">
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-265">
                  Month
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-266">
                  Move-Ins
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-267">
                  Move-Outs
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-268">
                  Net Change
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-269">
              <tr data-id="element-270">
                <td className="px-4 py-2" data-id="element-271">July</td>
                <td className="px-4 py-2 text-green-600" data-id="element-272">12</td>
                <td className="px-4 py-2 text-red-600" data-id="element-273">8</td>
                <td className="px-4 py-2 font-medium" data-id="element-274">+4</td>
              </tr>
              <tr data-id="element-275">
                <td className="px-4 py-2" data-id="element-276">August</td>
                <td className="px-4 py-2 text-green-600" data-id="element-277">9</td>
                <td className="px-4 py-2 text-red-600" data-id="element-278">5</td>
                <td className="px-4 py-2 font-medium" data-id="element-279">+4</td>
              </tr>
              <tr data-id="element-280">
                <td className="px-4 py-2" data-id="element-281">September</td>
                <td className="px-4 py-2 text-green-600" data-id="element-282">14</td>
                <td className="px-4 py-2 text-red-600" data-id="element-283">10</td>
                <td className="px-4 py-2 font-medium" data-id="element-284">+4</td>
              </tr>
              <tr className="bg-gray-50 font-medium" data-id="element-285">
                <td className="px-4 py-2" data-id="element-286">Quarter Total</td>
                <td className="px-4 py-2 text-green-600" data-id="element-287">35</td>
                <td className="px-4 py-2 text-red-600" data-id="element-288">23</td>
                <td className="px-4 py-2 font-medium" data-id="element-289">+12</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="bg-white rounded-lg shadow p-4" data-id="element-290">
          <h2 className="text-lg font-semibold mb-4" data-id="element-291">Unit Type Distribution</h2>
          <table className="min-w-full" data-id="element-292">
            <thead data-id="element-293">
              <tr className="bg-gray-50" data-id="element-294">
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-295">
                  Unit Type
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-296">
                  Total Units
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-297">
                  Occupied
                </th>
                <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-298">
                  Occupancy %
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-299">
              <tr data-id="element-300">
                <td className="px-4 py-2" data-id="element-301">Studio</td>
                <td className="px-4 py-2" data-id="element-302">42</td>
                <td className="px-4 py-2" data-id="element-303">38</td>
                <td className="px-4 py-2" data-id="element-304">90.5%</td>
              </tr>
              <tr data-id="element-305">
                <td className="px-4 py-2" data-id="element-306">One Bedroom</td>
                <td className="px-4 py-2" data-id="element-307">86</td>
                <td className="px-4 py-2" data-id="element-308">82</td>
                <td className="px-4 py-2" data-id="element-309">95.3%</td>
              </tr>
              <tr data-id="element-310">
                <td className="px-4 py-2" data-id="element-311">Two Bedroom</td>
                <td className="px-4 py-2" data-id="element-312">54</td>
                <td className="px-4 py-2" data-id="element-313">48</td>
                <td className="px-4 py-2" data-id="element-314">88.9%</td>
              </tr>
              <tr data-id="element-315">
                <td className="px-4 py-2" data-id="element-316">Memory Care</td>
                <td className="px-4 py-2" data-id="element-317">32</td>
                <td className="px-4 py-2" data-id="element-318">30</td>
                <td className="px-4 py-2" data-id="element-319">93.8%</td>
              </tr>
              <tr className="bg-gray-50 font-medium" data-id="element-320">
                <td className="px-4 py-2" data-id="element-321">All Units</td>
                <td className="px-4 py-2" data-id="element-322">214</td>
                <td className="px-4 py-2" data-id="element-323">198</td>
                <td className="px-4 py-2" data-id="element-324">92.5%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>;
};